/*
 * Copyright (C) 2024 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */

import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'ods-search-result-item',
  template: `
    <button
      #button
      data-test-id="item-button"
      class="hover:bg-background-150 focus:border-focus w-full border-2 border-transparent focus:outline-none"
      (click)="handleItemSelect($event)"
      (keydown.enter)="handleItemSelect($event)"
      role="option"
      tabindex="-1"
    >
      <ng-content />
    </button>
  `,
})
export class SearchResultItemComponent {
  @Output() itemSelected = new EventEmitter<void>();
  @ViewChild('button') buttonRef: ElementRef;

  public setFocus() {
    this.buttonRef.nativeElement.focus();
  }

  handleItemSelect(e: Event) {
    e.preventDefault();
    e.stopPropagation();
    this.itemSelected.emit();
  }
}
